var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { LineStyleType } from '../../../../view-data/shared/line/general/line-style-type';
var PolygonGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(PolygonGeneralSettingComponent, _super);
    function PolygonGeneralSettingComponent(injector, lineStyleTypeService) {
        var _this = _super.call(this, injector) || this;
        _this.lineStyleTypeService = lineStyleTypeService;
        _this.lineStyleTypes = [];
        _this.lineStyleTypes = _this.lineStyleTypeService.getAll();
        return _this;
    }
    Object.defineProperty(PolygonGeneralSettingComponent.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this.data.stroke = v;
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralSettingComponent.prototype, "strokeWidth", {
        get: function () {
            return this._strokeWidth;
        },
        set: function (v) {
            this.data.strokeWidth = v;
            this._strokeWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralSettingComponent.prototype, "selectedLineType", {
        get: function () {
            return this._selectedLineType;
        },
        set: function (v) {
            this.data.lineType = v.id;
            this._selectedLineType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonGeneralSettingComponent.prototype, "fill", {
        get: function () {
            return this._fill;
        },
        set: function (v) {
            this.data.fill = v;
            this._fill = v;
        },
        enumerable: true,
        configurable: true
    });
    PolygonGeneralSettingComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    PolygonGeneralSettingComponent.prototype.validateStrokeWidth = function () {
        if (_.isNil(this.strokeWidth) || this.strokeWidth < 0) {
            this.strokeWidth = this.preStrokeWidth;
            return;
        }
        this.preStrokeWidth = this.strokeWidth;
    };
    PolygonGeneralSettingComponent.prototype.initData = function () {
        var _this = this;
        this._stroke = this.data.stroke;
        this._strokeWidth = this.data.strokeWidth;
        this._fill = this.data.fill;
        this.preStrokeWidth = this.data.strokeWidth;
        if (this.data.lineType || +this.data.lineType === LineStyleType.Solid) {
            this.selectedLineType = this.lineStyleTypes.find(function (v) { return v.id === +_this.data.lineType; });
        }
        else {
            this.selectedLineType = this.lineStyleTypes[0];
        }
    };
    PolygonGeneralSettingComponent.prototype.setStrokeColor = function (color) {
        this.stroke = color;
    };
    PolygonGeneralSettingComponent.prototype.setFillColor = function (color) {
        this.fill = color;
    };
    __decorate([
        Input()
    ], PolygonGeneralSettingComponent.prototype, "data", void 0);
    PolygonGeneralSettingComponent = __decorate([
        Component({
            selector: 'polygon-general-setting',
            styles: [".polygon-general{ .form-inline-label{ float: left; margin-top:3px; } } .color-picker{ width: 100px; } .polygon-general-setting{ .polygon-general-color-picker{ float: left; z-index: 999; } } "],
            template: "<div [busyIf]=\"isLoading\" class=\"polygon-general\" class='polygon-general-setting'> <div class=\"fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <div class=\"fe-transverse-title\">{{lc(\"StraightLineColor\")}}:</div> <div class=\"fe-transverse-component color-picker design-color-picker polygon-general-color-picker\"> <color-picker [color]=\"stroke\" (sentColor)=\"setStrokeColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"SharpFill\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"fill\" (sentColor)=\"setFillColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-form-group clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"LineWidth\")}}:</div> <input type=\"number\" class=\"fe-vertical-input\" name=\"strokeWidth\" [(ngModel)]='strokeWidth' (change)=\"validateStrokeWidth()\" /> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"LineType\")}}:</div> <div class=\"fe-vertical-component\"> <ng-select [items]=\"lineStyleTypes\" bindLabel=\"name\" [(ngModel)]=\"selectedLineType\" [clearable]=\"false\" [searchable]=\"false\"> <ng-template ng-label-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> <ng-template ng-option-tmp let-item=\"item\"> <div [innerHTML]=\"item.name | safeHtml\"></div> </ng-template> </ng-select> </div> </div> </div> </div> </div>"
        })
    ], PolygonGeneralSettingComponent);
    return PolygonGeneralSettingComponent;
}(ConfigureComponentBase));
export { PolygonGeneralSettingComponent };
